import Entity from './entity'
export default class User extends Entity<number>{
    password:string;
    phoneNumber:string;
    agencyId : string;
    emailAddress: string;
    name:string;
    surname:string;
    isActive:boolean; 
    userName:string;

}